import React from "react";
import LeftContent from "components/notify/leftcontent";
import TopContent from "components/notify/topcontent";
import TableContent from "components/notify/tablecontent";
import LoadingPage from "components/LoadingPage";
import { useNotify } from "context/NotifyContext";

const MainContent = (props) => {
  const { filterData } = useNotify();
  let userData = window.$user_profile;
  if (filterData?.data === "") {
    return <LoadingPage />;
  }
  // console.log("Main Content");
  return (
    <div id="notify-content" className="inner-container row">
      <LeftContent userData={userData} />
      <div
        id="right-content"
        className="col s10"
        style={{ paddingLeft: "20px" }}
      >
        <TopContent userData={userData} />
        <TableContent userData={userData} />
      </div>
    </div>
  );
};

export default MainContent;
